import Web3 from "web3";

const address = "0xf3A909c0999407Fc20506925928fd78C6eF2939A";

window.ethereum.request({ method: "eth_requestAccounts" });

const web3 = new Web3(window.ethereum);

export default web3;
